export default __webpack_public_path__ + "static/media/information-circle.38aca4d3.svg";